import React, {useEffect, useState, useRef} from 'react'
import { SpinnerRoundOutlined } from 'spinners-react'

export const SizeList = ( {productId} ) => {
	const [ sizes, setSizes ] = useState([])
	const [ hasSizes, setHasSizes ] = useState(true)

	useEffect( () => {
		const getSizes = async () => {
			const data = new FormData()

			data.append( 'nonce', robinshoes_ajax_obj.nonce )
			data.append( 'action', 'get_sizes')
			data.append( 'productId', productId)

			const response = await fetch( robinshoes_ajax_obj.ajax_url, {
				method: 'POST',
				body: data
			})
			const result = await response.json()
			if ( result.length === 0 ) {
				setHasSizes(false)
				return
			}
			setSizes( result.map( size  => {
				return (
					<li
						className={size.stockstatus === 'notinstock' ? 'hasnostock' : ''}
						key={size.name}
						data-onclick={size.stockstatus === 'instock' ? 'switch-size' : ''}
					>
						{size.name}
					</li>
				)
			}))
		}
		getSizes()
	}, [])

	return (
		<>
			{sizes.length > 0 &&
			<>
				<ul className='product-archive__sizes product-sizes'>
					{sizes}
				</ul>
			</>
			}
			{sizes.length === 0 && hasSizes &&
				<>
					<SpinnerRoundOutlined size="30" color="rgb(170, 143, 14)" />
					<span className="loading-sizes">Maten worden geladen...</span>
				</>
			}
		</>
	)
}